const onSale = (addOn, now) => (
  !!addOn.start_time
    && !!addOn.end_time
    && new Date(addOn.start_time) < now
    && new Date(addOn.end_time) > now
    && !addOn.sold_out
    && addOn.available_tickets !== 0
);

export const lockedAddOns = (addOns, visibleAddOns, now = new Date()) => {
  const visibleIds = visibleAddOns.map((addOn) => addOn.id);

  return addOns
    .filter((addOn) =>
      (addOn.require_ticket_type || addOn.require_add_on)
        && !visibleIds.includes(addOn.id)
        && onSale(addOn, now)
    )
    .map((addOn) => (
      addOn.require_add_on
        ? Object.assign({}, addOn, {
          required_add_on_names: addOns
            .filter((ao) => (addOn.required_add_on_ids || []).includes(ao.id))
            .map((ao) => ao.base_name || ao.name)
        })
        : addOn
    ));
};

export const soldOutAddOns = (addOns, visibleAddOns, checkoutCategories, now = new Date()) => {
  if ((checkoutCategories || []).length > 0) {
    return [];
  }

  return visibleAddOns
    .concat(lockedAddOns(addOns, visibleAddOns, now))
    .sort((a, b) => a.position - b.position);
};

export const admissionTicketCount = (userContext) => (
  ((userContext && userContext.tickets) || []).filter((ticket) => ticket.ticket_type_id).length
);
